import {createApp, defineAsyncComponent} from 'vue';
import Navigation from '@/components/Navigation';
import FlipGallery from "@/components/FlipGallery";
import Quotes from "@/components/Quotes";
import AccordeonItem from "@/components/AccordeonItem";
import Slider from "@/components/Slider";
import { vfmPlugin } from 'vue-final-modal'
import Overlay from "@/components/Overlay";
import initVideo from "@/utils/video";
import VueSplide from '@splidejs/vue-splide';

const app = createApp({
  components: {
    Navigation,
    FlipGallery,
    Quotes,
    AccordeonItem,
    Overlay,
    Slider,
  },
}).use(VueSplide).use(vfmPlugin);

app.mount('#app')

// Video
let videos = document.getElementsByClassName('video');
if (videos.length >= 1) {
  for (let i = 0; i < videos.length; i++) {
    initVideo(videos[i].querySelector('iframe'), videos[i].querySelector('.video-toggle'), videos[i].querySelector('.hint') )
  }
}